import React from 'react';
import {Checkbox} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import ComboAccessoriesModal from './comboAccessoriesModal';
import ComboDealersModal from './comboDealersModal';
import {Actions} from '../../../common/actions';
import {useDispatch} from 'react-redux';

const {
  updateComboHeader,
} = Actions;

export const getColumns = (getChangeStatePermissions) => {
  const dispatch = useDispatch();

  const handleStatusToggleOnChange = (e, value, combo) => {
    e.preventDefault();
    const data = {'data': {...combo, 'status': value ? 'A' : 'I'}};
    dispatch(updateComboHeader(data));
  };

  const renderStateToggle = (combo) => {
    return <Checkbox toggle checked={combo.status === 'A' ? true : false} className='green'
      disabled={!getChangeStatePermissions()}
      onChange={(e, input) => handleStatusToggleOnChange(e, input.checked, combo)} />;
  };

  return [
    {
      'Header': 'CÓDIGO',
      'accessor': 'code',
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            <Link to={`/combos/editar/${row.original.code}`}>{row.original.code}</Link>
          </div>
        );
      },
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': 'TIPO INSTALACIÓN',
      'accessor': 'installType',
    },
    {
      'id': 'accessoriosCheck',
      'Header': 'ACCESORIOS',
      'width': '1',
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            <ComboAccessoriesModal code={row.original.code} />
          </div>
        );
      },
      'Filter': null,
    },
    {
      'id': 'hunterCheck',
      'Header': 'CONCESIONARIOS ',
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            <ComboDealersModal code={row.original.code} />
          </div>
        );
      },
      'Filter': null,
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'width': 2,
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            {renderStateToggle(row.original)}
          </div>
        );
      },
      'Filter': () => {
        return null;
      },
    },
  ];
};
